var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToggleButtonIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3,
    height: 14,
    viewBox: "0 0 3 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2694",
    "data-name": "Group 2694",
    transform: "translate(-295 -27)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_338",
    "data-name": "Ellipse 338",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(295 27)",
    fill: "#758CA1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_339",
    "data-name": "Ellipse 339",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(295 33)",
    fill: "#758CA1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_340",
    "data-name": "Ellipse 340",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(295 38)",
    fill: "#758CA1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleButtonIcon2);
export default __webpack_public_path__ + "static/media/toggle-button-icon-2.42bc6d0a.svg";
export { ForwardRef as ReactComponent };